import {
    Contract,
    RoyaltyModelType,
    RoyaltyModelTypes
} from '@amzn/coral_com-amazon-musicpapercontractconfigurationservice';

import { CORE_PLAN_MAPPING } from 'src/constants/rateCards';
import { CORE_RATE_GRID_PLAN_COLUMNS, ICoreRatesPlanConfiguration } from 'src/types/IRateCard';
import { notUndefined } from 'src/util/list-utils';

export function createPlanConfiguration(
    contract: Contract,
    royaltyModelTypes: RoyaltyModelTypes
): ICoreRatesPlanConfiguration {
    const planConfiguration: ICoreRatesPlanConfiguration = {};

    const royaltyModelTypeMap: { [id: number]: RoyaltyModelType } = {};
    royaltyModelTypes.forEach((rmt) => {
        if (typeof rmt.royaltyModelTypeId !== 'undefined') {
            royaltyModelTypeMap[rmt.royaltyModelTypeId] = rmt;
        }
    });

    CORE_RATE_GRID_PLAN_COLUMNS.forEach((corePlanColumn) => {
        const royaltyModelTypeCode = CORE_PLAN_MAPPING[corePlanColumn].royaltyModelTypeCode;

        const warnings = [];

        const paperPlanName = CORE_PLAN_MAPPING[corePlanColumn].paperPlanName;

        const modelTypeFrequency: { [modelTypeCode: string]: number } = {};

        contract.territoryTerms
            .flatMap((tt) => tt.rateCards)
            .filter(notUndefined)
            .filter((rc) => rc.paperPlanName === paperPlanName)
            .map((rc) => rc.royaltyModelType?.royaltyModelTypeId)
            .filter(notUndefined)
            .map((id) => royaltyModelTypeMap[id]?.royaltyModelTypeCode)
            .filter(notUndefined)
            .forEach((code) => (modelTypeFrequency[code] = (modelTypeFrequency[code] ?? 0) + 1));

        const modelTypeCodes = Object.keys(modelTypeFrequency);

        if (modelTypeCodes.length > 1) {
            warnings.push(
                `Found multiple Royalty Model Type Codes for ${corePlanColumn}: ${JSON.stringify(modelTypeCodes)}`
            );
        }

        let maxFrequency = 0;
        let mostFrequentModelTypeCode = royaltyModelTypeCode;

        modelTypeCodes.forEach((modelTypeCode) => {
            if (modelTypeFrequency[modelTypeCode] > maxFrequency) {
                maxFrequency = modelTypeFrequency[modelTypeCode];
                mostFrequentModelTypeCode = modelTypeCode;
            }
        });

        planConfiguration[corePlanColumn] = {
            royaltyModelTypeCode: mostFrequentModelTypeCode,
            corePlanModelCode: CORE_PLAN_MAPPING[corePlanColumn].royaltyModelCode,
            warnings: warnings
        };
    });

    return planConfiguration;
}
